import * as React from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Card,
  Stack,
  Button,
  Chip,
  Divider,
  FormHelperText,
  TextField,
  Box,
} from "@mui/material";
import { Loader, useAppConfig } from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { useSettings } from "../../Settings/hooks";
import { AsyncPaginate } from "react-select-async-paginate";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import { errorMessage } from "../../../utils";
import { useImmer } from "use-immer";

export const StoreSettings = () => {
  const { id } = useParams();
  const {
    state,
    globalData,
    HandleInputChange,
    onUpdateSettings,
    handleAddMaIL,
    handleDeleteMaIL,
    handleGetUserList,
    stateTemplates,
    handleOnChange,
  } = useSettings(id);
  const { currencySymbol } = useAppConfig();

  const { isLoading, details, isSaveButton } = state;

  const optionsTemplate = globalData?.eod_template?.map((item) => ({
    label: item.label,
    value: item.value,
  }));

  const navigate = useNavigate();
  const [input, setInput] = useImmer({
    email: null,
    discrepancy_alert_mails: null,
    missed_financial_mails: null,
    ytd_cal_ytd_variance_mails: null,
    overwrite_mails: null,
    web_order_fee_mails: null,
    refund_alert_emails: null,
  });

  const [, forceUpdate] = React.useState();

  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        refundAlert: {
          message:
            "At least one valid email is required when refund alert is enabled.",
          rule: (value) => {
            const { refund_alert_emails, refund_alert_enabled } = value;

            if (!refund_alert_enabled) return true;

            return refund_alert_emails?.length > 0;
          },
        },
      },
      element: (message) => message,
    }),
  );
  const validator2 = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => message,
    }),
  );

  const {
    variance_status,
    eod_variance,
    auto_log_status,
    auto_log_time,
    email,
    float_amount,
    sale_keypad_id,
    wastage_keypad_id,
    pre_order_days,
    delivery_radius,
    delivery,
    delivery_provider,
    eod_template,
    cart_product_count_limit,
    cart_product_waiting_time_limit,
    local_kds,
    dt_pick_up_available,

    // Franchisee new update
    discrepancy_alert_mails,
    missed_financial_mails,
    ytd_cal_ytd_variance_mails,
    overwrite_mails,
    show_upsell_in_pos,
    web_order_fee_mails,
    preorder_days_for_future_order,
    future_order_enabled,
    vip_card_prompt,
    refund_alert_amount,
    refund_alert_emails,
    refund_alert_enabled,
    public_holiday_fee_enabled,
  } = details;

  const optionTemplates = stateTemplates?.templates?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const optionWatageTemplates = stateTemplates?.wastageTemplate?.map(
    (item) => ({
      label: item.name,
      value: item.id,
    }),
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      onUpdateSettings();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const onADD = ({ options, type }) => {
    if (validator2.current.fieldValid(type)) {
      if (options && options.some((v) => v.email === input[type])) {
        errorMessage("This email already exist.");
      } else {
        handleAddMaIL({ input: input[type], type });
        resetInput({ type });
        validator2.current.hideMessageFor(type);
        forceUpdate(0);
      }
    } else {
      validator2.current.showMessageFor(type);
      forceUpdate(1);
    }
  };

  const onInputChange = ({ type, inputValue, action }) => {
    if (action === "input-change") {
      setInput((draft) => {
        draft[type] = inputValue;
      });
    }
  };

  const resetInput = ({ type }) => {
    setInput((draft) => {
      draft[type] = null;
    });
  };

  const onEmailChange = ({ event, value, type, options }) => {
    if (value.action === "clear") {
      resetInput({ type });

      validator2.current.hideMessageFor(type);
    } else if (value.action === "pop-value") {
      resetInput({ type });
    } else if (
      options &&
      options.some((val) => val.email === value.option.email)
    ) {
      errorMessage("This email already exist.");
      resetInput({ type });
      validator2.current.hideMessageFor(type);
    } else {
      HandleInputChange({
        target: {
          name: type,
          value: event,
        },
      });
      validator2.current.hideMessageFor(type);
    }
  };

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <>
        {data.custom ? (
          <Stack
            ref={innerRef}
            {...innerProps}
            sx={{
              flexDirection: "row",
              p: "7px 8px",
              gap: "2px",
              alignItems: "center",
            }}
          >
            <AddIcon
              sx={{
                color: "#1560D4",
              }}
            />

            <Link
              target="_blank"
              sx={{ textDecoration: "none" }}
              onClick={() => navigate("/client-account/customer/create")}
            >
              Add new User
            </Link>
          </Stack>
        ) : (
          <Stack
            ref={innerRef}
            {...innerProps}
            sx={{
              flexDirection: "row",

              p: "7px 8px",

              gap: "2px",
            }}
          >
            <Stack
              sx={{
                gap: "2px",
              }}
            >
              <Typography
                variant="subtitle2"
                fontWeight={400}
                lineHeight="17px"
              >
                {data.name}
              </Typography>
              <Typography color="#666666" variant="caption" lineHeight="15px">
                {data.email}
              </Typography>
            </Stack>
          </Stack>
        )}
      </>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "8px",
      border: "2px solid #E6E8F0",
      height: "48px",
    }),
    option: (provided, state) => ({
      ...provided,
      maxHeight: "239px",
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 99,
    }),
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {validator.current.purgeFields()}
          <Card sx={{ mb: "230px", overflow: "inherit" }}>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                p: "24px",
                position: "sticky",
                top: "176px",
                zIndex: 1199,
                background: "#fff",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Settings
              </Typography>
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={onSubmit}
                disabled={isSaveButton}
              >
                Save
              </Button>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Terminal Auto Log Off
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Time (In Seconds)"
                    type="number"
                    name="auto_log_time"
                    value={auto_log_time}
                    onChange={HandleInputChange}
                    isDisabledKeys={["-"]}
                    error={
                      auto_log_status
                        ? validator.current.message(
                            "Time (In Seconds)",
                            auto_log_time,
                            "required",
                          )
                        : null
                    }
                    helperText={
                      auto_log_status
                        ? validator.current.message(
                            "Time (In Seconds)",
                            auto_log_time,
                            "required",
                          )
                        : null
                    }
                    disabled={!auto_log_status}
                  />
                  <InputControl
                    type="switch"
                    name="auto_log_status"
                    value={auto_log_status}
                    onChange={(e) => {
                      HandleInputChange({
                        target: {
                          name: "auto_log_status",
                          value: e.target.checked ? 1 : 0,
                        },
                      });
                    }}
                  />
                </Stack>

                <Typography
                  variant="subtitle2"
                  color="#636363"
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "18px" }}
                    alt="details"
                    src="/icons/ic_info.svg"
                  />{" "}
                  Default time to auto log off is 30 seconds.
                </Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                EOD Variance
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Variance"
                    type="number"
                    name="eod_variance"
                    value={eod_variance}
                    onChange={HandleInputChange}
                    isDoller={true}
                    currencySymbol={currencySymbol}
                    isDisabledKeys={["-"]}
                    error={
                      variance_status
                        ? validator.current.message(
                            "Variance",
                            eod_variance,
                            "required",
                          )
                        : null
                    }
                    helperText={
                      variance_status
                        ? validator.current.message(
                            "Variance",
                            eod_variance,
                            "required",
                          )
                        : null
                    }
                    disabled={!variance_status}
                  />
                  <InputControl
                    type="switch"
                    name="variance_status"
                    value={variance_status}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "variance_status",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>

                <Typography
                  variant="subtitle2"
                  color="#636363"
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "18px" }}
                    alt="details"
                    src="/icons/ic_info.svg"
                  />
                  User will be prompted to re-count and submit if variance is
                  greater than this value.
                </Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                EOD Template
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="dropdown"
                    disableClearable
                    options={optionsTemplate ?? []}
                    disabled
                    getOptionLabel={(option) => option.label}
                    value={
                      (optionsTemplate?.length > 0 &&
                        toString(eod_template) &&
                        optionsTemplate?.find(
                          (c) => c?.value === eod_template,
                        )) ||
                      null
                    }
                    onChange={(e, newValue) => {
                      handleOnChange(newValue, "eod_template");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="EOD Template"
                        required
                        error={validator.current.message(
                          "EOD Template",
                          eod_template,
                          "required",
                        )}
                        helperText={validator.current.message(
                          "EOD Template",
                          eod_template,
                          "required",
                        )}
                      />
                    )}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />

            {/* Email */}
            <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  EOD Summary Mail
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="16px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.email}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({ type: "email", inputValue, action })
                        }
                        value={email}
                        key={JSON.stringify(email)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({ search: e, type: "email" })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "email",
                            options: email,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "email",
                          input.email,
                          "required|email",
                        )}
                      </FormHelperText>
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: email,
                          type: "email",
                        })
                      }
                      disabled={Boolean(!input.email)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {email.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "email",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider />

            {/* Alert for YTD Profit Discrepancy */}
            {/* <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Alert for YTD Profit Discrepancy
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="20px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%" gap="4px">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.discrepancy_alert_mails}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({
                            type: "discrepancy_alert_mails",
                            inputValue,
                            action,
                          })
                        }
                        value={discrepancy_alert_mails}
                        key={JSON.stringify(discrepancy_alert_mails)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({
                            search: e,
                            type: "discrepancy_alert_mails",
                          })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "discrepancy_alert_mails",
                            options: discrepancy_alert_mails,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "discrepancy_alert_mails",
                          input.discrepancy_alert_mails,
                          "required|email",
                        )}
                      </FormHelperText>
                      <FormFieldInfo
                        info={
                          "The added email addresses will receive a discrepancy alert Mail."
                        }
                      />
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: discrepancy_alert_mails,
                          type: "discrepancy_alert_mails",
                        })
                      }
                      disabled={Boolean(!input.discrepancy_alert_mails)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {discrepancy_alert_mails.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "discrepancy_alert_mails",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider /> */}

            {/* Alert for Missed Financial */}
            {/* <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Alert for Missed Financial
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="20px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%" gap="4px">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.missed_financial_mails}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({
                            type: "missed_financial_mails",
                            inputValue,
                            action,
                          })
                        }
                        value={missed_financial_mails}
                        key={JSON.stringify(missed_financial_mails)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({
                            search: e,
                            type: "missed_financial_mails",
                          })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "missed_financial_mails",
                            options: missed_financial_mails,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "missed_financial_mails",
                          input.missed_financial_mails,
                          "required|email",
                        )}
                      </FormHelperText>
                      <FormFieldInfo
                        info={
                          "The added email addresses will be notified of the missed financial report."
                        }
                      />
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: missed_financial_mails,
                          type: "missed_financial_mails",
                        })
                      }
                      disabled={Boolean(!input.missed_financial_mails)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {missed_financial_mails.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "missed_financial_mails",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider /> */}

            {/* Alert for Account File Overwrite */}
            {/* <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Alert for Account File Overwrite
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="20px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%" gap="4px">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.overwrite_mails}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({
                            type: "overwrite_mails",
                            inputValue,
                            action,
                          })
                        }
                        value={overwrite_mails}
                        key={JSON.stringify(overwrite_mails)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({
                            search: e,
                            type: "overwrite_mails",
                          })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "overwrite_mails",
                            options: overwrite_mails,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "overwrite_mails",
                          input.overwrite_mails,
                          "required|email",
                        )}
                      </FormHelperText>
                      <FormFieldInfo
                        info={
                          "The added email addresses will be notified about the Account File overwrite requests."
                        }
                      />
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: overwrite_mails,
                          type: "overwrite_mails",
                        })
                      }
                      disabled={Boolean(!input.overwrite_mails)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {overwrite_mails.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "overwrite_mails",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider /> */}

            {/* Alert for File YTD & Cal.YTD Variance */}
            {/* <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Alert for File YTD & Cal.YTD Variance
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="20px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%" gap="4px">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.ytd_cal_ytd_variance_mails}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({
                            type: "ytd_cal_ytd_variance_mails",
                            inputValue,
                            action,
                          })
                        }
                        value={ytd_cal_ytd_variance_mails}
                        key={JSON.stringify(ytd_cal_ytd_variance_mails)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({
                            search: e,
                            type: "ytd_cal_ytd_variance_mails",
                          })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "ytd_cal_ytd_variance_mails",
                            options: ytd_cal_ytd_variance_mails,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "ytd_cal_ytd_variance_mails",
                          input.ytd_cal_ytd_variance_mails,
                          "required|email",
                        )}
                      </FormHelperText>
                      <FormFieldInfo
                        info={
                          "The added email addresses will be notified about the file YTD and Cal.YTD Variance."
                        }
                      />
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: ytd_cal_ytd_variance_mails,
                          type: "ytd_cal_ytd_variance_mails",
                        })
                      }
                      disabled={Boolean(!input.ytd_cal_ytd_variance_mails)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {ytd_cal_ytd_variance_mails.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "ytd_cal_ytd_variance_mails",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider /> */}

            {/* <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Web Order Fee Report
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="20px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%" gap="4px">
                      <AsyncPaginate
                        debounceTimeout={1000}
                        placeholder="Add Mail address"
                        className="AsyncPaginate-dropdown"
                        classNamePrefix="react-select"
                        isMulti
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        inputValue={input.web_order_fee_mails}
                        onInputChange={(inputValue, { action }) =>
                          onInputChange({
                            type: "web_order_fee_mails",
                            inputValue,
                            action,
                          })
                        }
                        value={web_order_fee_mails}
                        key={JSON.stringify(web_order_fee_mails)}
                        components={{ Option: CustomOption }}
                        loadOptions={(e) =>
                          handleGetUserList({
                            search: e,
                            type: "web_order_fee_mails",
                          })
                        }
                        onChange={(event, value) =>
                          onEmailChange({
                            event,
                            value,
                            type: "web_order_fee_mails",
                            options: web_order_fee_mails,
                          })
                        }
                        controlShouldRenderValue={false}
                        additional={{
                          page: 1,
                        }}
                        styles={customStyles}
                      />
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator2.current.message(
                          "web_order_fee_mails",
                          input.web_order_fee_mails,
                          "required|email",
                        )}
                      </FormHelperText>
                      <FormFieldInfo
                        info={
                          "The added email addresses will receive the Summary of the Order Fee report."
                        }
                      />
                    </Stack>
                    <Button
                      sx={{
                        height: "44px !important",
                      }}
                      onClick={() =>
                        onADD({
                          options: web_order_fee_mails,
                          type: "web_order_fee_mails",
                        })
                      }
                      disabled={Boolean(!input.web_order_fee_mails)}
                    >
                      Add
                    </Button>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "16px",
                      rowGap: "8px",
                    }}
                  >
                    {web_order_fee_mails?.map((data, index) => (
                      <Chip
                        key={index}
                        label={
                          <Typography variant="subtitle2">
                            {data.name || data.email}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteMaIL({
                            type: "web_order_fee_mails",
                            email: data.email,
                          });
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          height: "30px",
                          "& .MuiChip-deleteIcon": {
                            color: "#CCCCCC",
                          },
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider /> */}
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Scheduled Ordering
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (POS)
                </Box>
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="future_order_enabled"
                    value={future_order_enabled}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "future_order_enabled",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>
                <div>
                  <InputControl
                    label="Pre-Order Days"
                    type="number"
                    name="preorder_days_for_future_order"
                    value={preorder_days_for_future_order}
                    width="300px"
                    onChange={HandleInputChange}
                  />

                  <Typography
                    variant="caption"
                    color="#636363"
                    sx={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                      mt: "4px",
                    }}
                  >
                    <img
                      alt="sign"
                      src="/icons/ic_info_small.png"
                      height="20px"
                    />
                    Defines how many days in advance customers can schedule
                    their orders.
                  </Typography>
                </div>
              </Stack>
            </Stack>
            <Divider />

            {/* <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                POS Upsell Prompt
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="show_upsell_in_pos"
                    value={show_upsell_in_pos}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "show_upsell_in_pos",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>

                <Typography
                  variant="subtitle2"
                  color="#636363"
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "18px" }}
                    alt="details"
                    src="/icons/ic_info.svg"
                  />
                  Enable to display upselling suggestions for items added to
                  cart in POS app.
                </Typography>
              </Stack>
            </Stack>
            <Divider /> */}
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Apply Public Holiday Surcharge
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="public_holiday_fee_enabled"
                    value={public_holiday_fee_enabled}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "public_holiday_fee_enabled",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>

                <Typography
                  variant="subtitle2"
                  color="#636363"
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "18px" }}
                    alt="details"
                    src="/icons/ic_info.svg"
                  />
                  Enable this to apply an additional charge on orders placed
                  during public holidays for this store.
                </Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Loyalty Card Prompt
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (POS)
                </Box>
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="vip_card_prompt"
                    value={vip_card_prompt}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "vip_card_prompt",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>

                <Typography
                  variant="subtitle2"
                  color="#636363"
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "18px" }}
                    alt="details"
                    src="/icons/ic_info.svg"
                  />
                  Enable to prompt guest users to scan a loyalty card before
                  payment in POS app.
                </Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Refund Alert
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="refund_alert_enabled"
                    value={refund_alert_enabled}
                    onChange={(e) =>
                      HandleInputChange({
                        target: {
                          name: "refund_alert_enabled",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </Stack>
                {!!refund_alert_enabled && (
                  <>
                    <div>
                      <InputControl
                        label="Alert Amount *"
                        type="number"
                        name="refund_alert_amount"
                        value={refund_alert_amount}
                        isDoller={true}
                        currencySymbol={currencySymbol}
                        onChange={HandleInputChange}
                        width="200px"
                        error={
                          refund_alert_enabled
                            ? validator.current.message(
                                "Alert Amount",
                                refund_alert_amount,
                                "required",
                              )
                            : null
                        }
                        helperText={
                          refund_alert_enabled
                            ? validator.current.message(
                                "Alert Amount",
                                refund_alert_amount,
                                "required",
                              )
                            : null
                        }
                      />

                      <Typography
                        variant="caption"
                        color="#636363"
                        sx={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          mt: "4px",
                        }}
                      >
                        <img
                          alt="sign"
                          src="/icons/ic_info_small.png"
                          height="20px"
                        />
                        Refunds equal to or above this amount will trigger
                        instant alerts.
                      </Typography>
                    </div>
                    <Stack width="100%" gap="20px">
                      <Stack direction={"row"} gap="20px">
                        <Stack width="100%" gap="4px">
                          <AsyncPaginate
                            debounceTimeout={1000}
                            placeholder={`Add Mail address${
                              refund_alert_enabled ? " *" : ""
                            }`}
                            className="AsyncPaginate-dropdown"
                            classNamePrefix="react-select"
                            isMulti
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            inputValue={input.refund_alert_emails}
                            onInputChange={(inputValue, { action }) =>
                              onInputChange({
                                type: "refund_alert_emails",
                                inputValue,
                                action,
                              })
                            }
                            value={refund_alert_emails}
                            key={JSON.stringify(refund_alert_emails)}
                            components={{ Option: CustomOption }}
                            loadOptions={(e) =>
                              handleGetUserList({
                                search: e,
                                type: "refund_alert_emails",
                              })
                            }
                            onChange={(event, value) =>
                              onEmailChange({
                                event,
                                value,
                                type: "refund_alert_emails",
                                options: refund_alert_emails,
                              })
                            }
                            controlShouldRenderValue={false}
                            additional={{
                              page: 1,
                            }}
                            styles={customStyles}
                          />
                          <FormHelperText sx={{ color: "#C60808" }}>
                            {validator2.current.message(
                              "refund_alert_emails",
                              input.refund_alert_emails,
                              "required|email",
                            )}
                          </FormHelperText>
                          <FormHelperText sx={{ color: "#C60808" }}>
                            {validator.current.message(
                              "refund_alert_email",
                              { refund_alert_emails, refund_alert_enabled },
                              `refundAlert`,
                            )}
                          </FormHelperText>
                          <FormFieldInfo
                            info={
                              "Added email addresses will receive refund alerts and daily summaries."
                            }
                          />
                        </Stack>
                        <Button
                          sx={{
                            height: "44px !important",
                          }}
                          onClick={() =>
                            onADD({
                              options: refund_alert_emails,
                              type: "refund_alert_emails",
                            })
                          }
                          disabled={Boolean(!input.refund_alert_emails)}
                        >
                          Add
                        </Button>
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "16px",
                          rowGap: "8px",
                        }}
                      >
                        {refund_alert_emails?.map((data, index) => (
                          <Chip
                            key={index}
                            label={
                              <Typography variant="subtitle2">
                                {data.name || data.email}
                              </Typography>
                            }
                            onDelete={() => {
                              handleDeleteMaIL({
                                type: "refund_alert_emails",
                                email: data.email,
                              });
                            }}
                            sx={{
                              backgroundColor: "#F2F2F2",
                              height: "30px",
                              "& .MuiChip-deleteIcon": {
                                color: "#CCCCCC",
                              },
                            }}
                          />
                        ))}
                      </Stack>
                    </Stack>
                  </>
                )}
              </Stack>
            </Stack>
            <Divider />

            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Float Amount
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Float Amount"
                    type="number"
                    name="float_amount"
                    value={float_amount}
                    isDoller={true}
                    currencySymbol={currencySymbol}
                    onChange={HandleInputChange}
                    error={validator.current.message(
                      "Float Amount",
                      float_amount,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "Float Amount",
                      float_amount,
                      "required",
                    )}
                  />
                </Stack>
              </Stack>
            </Stack>

            <Divider />
            <Stack direction="row" p="24px">
              <Stack direction="row" gap="4px">
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  width="200px"
                  lineHeight="19px"
                >
                  Keypad Template
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack width="100%" gap="16px">
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%">
                      <InputControl
                        type="dropdown"
                        name="conditions"
                        disableClearable
                        options={optionTemplates}
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange(newValue, "sale_keypad_id");
                        }}
                        value={
                          (optionTemplates?.length > 0 &&
                            sale_keypad_id &&
                            optionTemplates?.find(
                              (c) => c.value === sale_keypad_id,
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Sale Template"
                            required
                            error={validator.current.message(
                              "Sale Template",
                              sale_keypad_id,
                              "required",
                            )}
                            helperText={validator.current.message(
                              "Sale Template",
                              sale_keypad_id,
                              "required",
                            )}
                          />
                        )}
                      />
                    </Stack>
                    <Button
                      onClick={() =>
                        navigate(`/sales-screen-layout/edit/${sale_keypad_id}`)
                      }
                      sx={{ minWidth: "160px" }}
                      disabled={!sale_keypad_id}
                    >
                      View Template
                    </Button>
                  </Stack>
                  <Stack direction={"row"} gap="20px">
                    <Stack width="100%">
                      <InputControl
                        type="dropdown"
                        name="conditions"
                        disableClearable
                        options={optionWatageTemplates}
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange(newValue, "wastage_keypad_id");
                        }}
                        value={
                          (optionWatageTemplates?.length > 0 &&
                            wastage_keypad_id &&
                            optionWatageTemplates?.find(
                              (c) => c.value === wastage_keypad_id,
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Wastage Template"
                            required
                            error={validator.current.message(
                              "Wastage Template",
                              wastage_keypad_id,
                              "required",
                            )}
                            helperText={validator.current.message(
                              "Wastage Template",
                              wastage_keypad_id,
                              "required",
                            )}
                          />
                        )}
                      />
                    </Stack>
                    <Button
                      onClick={() =>
                        navigate(
                          `/sales-screen-layout/edit/${wastage_keypad_id}`,
                        )
                      }
                      sx={{ minWidth: "160px" }}
                      disabled={!wastage_keypad_id}
                    >
                      View Template
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            {/*online ordering start */}
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Delivery Available
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (Online Ordering)
                </Box>
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <InputControl
                  type="switch"
                  name="variance_status"
                  value={delivery}
                  onChange={(e) =>
                    HandleInputChange({
                      target: {
                        name: "delivery",
                        value: e.target.checked ? 1 : 0,
                      },
                    })
                  }
                />
                <Stack
                  sx={{
                    width: "100%",
                    gap: "16px",
                  }}
                  mt={2}
                >
                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: "16px",
                    }}
                  >
                    <>
                      <InputControl
                        type="dropdown"
                        name="delivery_provider"
                        disableClearable
                        options={
                          globalData?.delivery_provider_customerApp ?? []
                        }
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange(newValue, "delivery_provider");
                        }}
                        value={
                          (globalData?.delivery_provider_customerApp?.length >
                            0 &&
                            delivery_provider &&
                            globalData?.delivery_provider_customerApp?.find(
                              (c) => c.value === delivery_provider,
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Provider"
                            required={delivery === 1}
                            error={
                              delivery === 1 &&
                              validator.current.message(
                                "Provider",
                                delivery_provider,
                                "required",
                              )
                            }
                            helperText={
                              delivery === 1 &&
                              validator.current.message(
                                "Provider",
                                delivery_provider,
                                "required",
                              )
                            }
                          />
                        )}
                      />
                      <InputControl
                        label="Radius (km)"
                        type="number"
                        name="delivery_radius"
                        value={delivery_radius}
                        onChange={HandleInputChange}
                        required={delivery === 1}
                        error={
                          delivery === 1 &&
                          validator.current.message(
                            "Radius (km)",
                            delivery_radius,
                            "required",
                          )
                        }
                        helperText={
                          delivery === 1 &&
                          validator.current.message(
                            "Radius (km)",
                            delivery_radius,
                            "required",
                          )
                        }
                      />
                    </>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Pre Order Days
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (Online Ordering)
                </Box>
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Days"
                    type="number"
                    name="pre_order_days"
                    value={pre_order_days}
                    onChange={HandleInputChange}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Cart Quantity Threshold
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (Online Ordering)
                </Box>
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Product Count"
                    type="number"
                    name="cart_product_count_limit"
                    value={cart_product_count_limit}
                    onChange={HandleInputChange}
                    required
                    error={validator.current.message(
                      "Product Count",
                      cart_product_count_limit,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "Product Count",
                      cart_product_count_limit,
                      "required",
                    )}
                  />
                  <InputControl
                    label="Waiting Time(In minutes)"
                    type="number"
                    name="cart_product_waiting_time_limit"
                    value={cart_product_waiting_time_limit}
                    onChange={HandleInputChange}
                    required
                    error={validator.current.message(
                      "Waiting Time(In minutes)",
                      cart_product_waiting_time_limit,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "Waiting Time(In minutes)",
                      cart_product_waiting_time_limit,
                      "required",
                    )}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px" alignItems="center" gap="16px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                width="185px"
              >
                Drive Through Online Order Collection
                <Box
                  sx={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: 400,
                    color: "#636363",
                  }}
                >
                  (Online Ordering)
                </Box>
              </Typography>
              <Stack
                sx={
                  {
                    // width: "100%",
                  }
                }
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="dt_pick_up_available"
                    value={dt_pick_up_available}
                    onChange={(e) => {
                      HandleInputChange({
                        target: {
                          name: "dt_pick_up_available",
                          value: e.target.checked ? 1 : 0,
                        },
                      });
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            {/* online ordering end */}
            {/* <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={400}
                lineHeight="19px"
                minWidth="200px"
              >
                Enable Local Communication
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    gap: "6px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="local_kds"
                    value={local_kds}
                    onChange={(e) => {
                      HandleInputChange({
                        target: {
                          name: "local_kds",
                          value: e.target.checked ? 1 : 0,
                        },
                      });
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    color="#636363"
                    sx={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      style={{ height: "18px" }}
                      alt="details"
                      src="/icons/ic_info.svg"
                    />
                    If enabled, communication between tills and from tills to
                    KDS will take place locally.
                  </Typography>
                </Stack>
              </Stack>
            </Stack> */}
          </Card>
        </>
      )}
    </>
  );
};

const FormFieldInfo = ({ info }) => (
  <Typography
    variant="subtitle2"
    color="#636363"
    sx={{
      display: "flex",
      gap: "4px",
      alignItems: "center",
    }}
  >
    <img style={{ height: "18px" }} alt="details" src="/icons/ic_info.svg" />
    {info}
  </Typography>
);
